import { Navigate, useLocation } from 'react-router-dom';

/**
 * `/points/return` — Mentor 付款完的回跳落點(傳給 Creative BE 的 return_url)。
 * 只做一件事:帶著查詢字串轉到 `/points`,由點數頁讀回跳參數、洗網址、輪詢入點。
 * 回跳另開一條路徑(而不是直接回 `/points`)是為了讓 return_url 的意圖在網址上看得出來,
 * 也讓 BE / Mentor 的白名單可以只放這一條。
 */
export function PointsReturnRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/points${search}`} replace />;
}
